import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

const readOutput = (res: any): any[] => {
  if (Array.isArray(res?.output)) return res.output;
  if (Array.isArray(res?.pathChildrenList)) return res.pathChildrenList;
  if (Array.isArray(res?.courseChildrenList)) return res.courseChildrenList;
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.items)) return res.items;
  if (Array.isArray(res?.content)) return res.content;
  return [];
};

export const fetchAllPages = async <T = any>(
  baseUrl: string,
  pageSize = 100,
  suppressErrors = true,
): Promise<T[]> => {
  const withPage = (page: number): string => {
    const sep = baseUrl.includes("?") ? "&" : "?";
    return `${baseUrl}${sep}page=${page}&page_size=${pageSize}`;
  };

  try {
    const first = await fetcher(withPage(0), MethodType.GET);
    const firstItems = readOutput(first) as T[];
    const totalPages = Number(first?.metadata?.total_pages) || 1;
    if (totalPages <= 1) return firstItems;

    const rest = await Promise.all(
      Array.from({ length: totalPages - 1 }, (_, i) =>
        fetcher(withPage(i + 1), MethodType.GET)
          .then(readOutput)
          .catch((error) => {
            if (!suppressErrors) throw error;
            return [] as any[];
          }),
      ),
    );
    return [firstItems, ...rest].flat() as T[];
  } catch (error) {
    if (!suppressErrors) throw error;
    return [];
  }
};
